import React, {
    useState,
    useEffect,
    useImperativeHandle,
    useRef,
  } from "react";
  import moment from "moment";
  import { Tooltip } from 'react-tooltip';
  import itLocale from "moment/locale/it";
  import List from "@mui/material/List";
  import { Swiper, SwiperSlide } from "swiper/react";
  import 'swiper/css';
  import 'swiper/css/navigation';
  import { Navigation, Virtual, Mousewheel, FreeMode } from 'swiper/modules';
  import ExCalendarTile from "./ExCalendarTile";
  import styles from "./ExCalendar.module.scss";
import useMobile from "../../hooks/useMobile";
  
  // converting this to italian.
  moment.locale('it', [itLocale]);

  const ExCalendar = (props) => {
    const isMobile = useMobile();
    // contains selected Date and based on this, we perform diff actions.
    const [selectedDate, setSelectedDate] = useState(moment(props.selectedDay).format("DDMMMYYYY"));
    // this actually contains all days, days could be 30 OR 60 based on what our backend returns us.
    const [getOneMonth, setGetOneMonth] = useState();
    const [clickable, setClickable] = useState(true);
  
    // Based on the preferences which is coming form our database, we are 
    // setting up the calandar.
    useEffect(() => {
      let days = 0;
      if (props.preferences) {
        if (props.preferences.numberOfDays) {
          days = parseInt(props.preferences.numberOfDays);
          const prev = moment();
          const fromDate = moment().add(days, "day");
          const dates = enumerateDaysBetweenDates(prev, fromDate);
          setGetOneMonth(dates);
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.preferences]);
  
    // Preparing calandar days and checking disabled days as well which are returning form our backend.
    const enumerateDaysBetweenDates = function (startDate, endDate) {
      const dates = [];
      let now = startDate;
      while (now.isBefore(endDate)) {
        const val = now.format("YYYY-MM-DD");
        const isHoliday = props.preferences.disabledDays.includes(val);
        const isNoAvailableSlots = props.noAvailableSlots.includes(val);
        const isLastOfYear = isLastDateOfYear(now);
        const obj = {
          isYearSeparator: false,
          date: now.format("ddd"),
          day: now.format("DD"),
          month: now.format("MMM"),
          weekday: now.weekday(),
          year: now.format("YYYY"),
          isUnavailable: false,
          isHoliday: isHoliday,
          isNoAvailableSlots: isNoAvailableSlots
        };
        dates.push(obj);
        if (isLastOfYear) {
          dates.push({
            ...obj,
            year: now.add("1", "day").format("YYYY"),
            isYearSeparator: true,
          });
        }
        now = now.add(1, "days");
      }
      return dates;
    };
    
    const selectedDateFunc = (value, index) => {
      const formattedDate = moment(value, "DDMMMYYYY");
      setSelectedDate(value);
      props.onDateChanged(formattedDate._d);
    };
  
    function capitalizeFirstLetter(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  
    function isLastDateOfYear(date) {
      const currentYear = date.year();
  
      const nextDay = date.clone().add(1, "day");
      const nextYear = nextDay.year();
  
      return nextYear !== currentYear;
    }
    const ref = useRef(null);
  
    useImperativeHandle(ref, () => ({
      slideToToday: () => {
        setClickable(true);
      },
      selectedDateFunc: (day, month, year) => {
        var index = getOneMonth?.findIndex(
          (x) => x.day === day && x.month === month && x.year === year
        );
        setSelectedDate(day + month + year);
        selectedDateFunc(day + month + year, index);
      },
    }));
  
    const sliders = () => {
      return getOneMonth?.map((i, index) => {
        return (
          <SwiperSlide>
            <List key={"List-" + index} sx={{ display: 'flex', justifyContent: 'center' }}>
              {!i.isYearSeparator && (
                <>
                  <div
                    onClick={() => {
                      if (clickable && i.isYearSeparator !== true && !i.isHoliday && !i.isNoAvailableSlots) {
                        selectedDateFunc(i.day + i.month + i.year, index);
                      }
                    }}
                    style={{ position: "relative" }}
                    data-tooltip-id={(i.isNoAvailableSlots && !i.isHoliday) ? "info-icon-tooltip" : ""}
                    data-tooltip-content="Nessun orario disponibile"
                    data-tooltip-place={isMobile ? "bottom-end" : "top-start"}
                  >
                    
                    {
                      <ExCalendarTile
                        isSelected={selectedDate === i.day + i.month + i.year}
                        isDisabled={false}
                        isNoAvailableSlots={i.isNoAvailableSlots}
                        isUnavailable={i.isUnavailable}
                        showAsDisabled={i.isHoliday}
                        day={i.date.toUpperCase()}
                        numDay={i.day}
                        month={i.month.toUpperCase()}
                        key={i.day + i.month + i.year}
                      ></ExCalendarTile>
                    }
                    {i.isHoliday && <div style={{
                      width: '1px',
                      height: '80%',
                      position: 'absolute',
                      top: 10,
                      left: 50,
                      transform: 'rotate(25deg)',
                      transformOrigin: 'top left',
                      background: '#222',
                    }} />}
                  </div>
                  {(i.isNoAvailableSlots && !i.isHoliday) && <Tooltip
                    id="info-icon-tooltip"
                    className={styles["infoTooltip"]}
                    place="top-end"
                    type="light"
                    style={{
                      width: isMobile ? "120px" : "200px",
                      backgroundColor: "white",
                      boxShadow: "-0px -0px 10px #2222221A",
                      color: "#222",
                      opacity: "1",
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "19px",
                      letterSpacing: "0em",
                      textAlign: "left",
                    }}
                  />}
                </>
              )}
              {i.isYearSeparator && (
                <div>
                  <ExCalendarTile
                    isSelected={false}
                    isDisabled={false}
                    isUnavailable={false}
                    showAsDisabled={false}
                    showJustYear={true}
                    year={i.year}
                    day={
                      !i.isHoliday
                        ? i.date.toUpperCase()
                        : capitalizeFirstLetter(i.date)
                    }
                    numDay={i.day}
                    month={i.month.toUpperCase()}
                    key={i.day + i.month + i.year}
                  ></ExCalendarTile>
                </div>
              )}
            </List>
          </SwiperSlide>
        );
      });
    };
  
    return (
      <div className={styles["ex-calendar-container"]}>
        <div className={styles["slider-container"]}>
          <Swiper
            spaceBetween={1}
            slidesPerView={15}
            navigation={true}
            modules={[Navigation, Virtual, Mousewheel, FreeMode]}
            freeMode={true}
            virtual={{
              enabled: true,
              addSlidesAfter: 25,
              addSlidesBefore: 25,
            }}
            mousewheel={{
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 0.5,
            }}
            breakpoints={{
              320: { slidesPerView: 4 },
              540: { slidesPerView: 6 },
              640: { slidesPerView: 6 },
              750: { slidesPerView: 6 },
              800: { slidesPerView: 6 },
              900: { slidesPerView: 9 },
              1090: { slidesPerView: 11 },
              1200: { slidesPerView: 12 },
              1440: { slidesPerView: 13 },
              1640: { slidesPerView: 13 },
              1800: { slidesPerView: 14 },
            }}
          >
            {sliders()}
          </Swiper>
        </div>
      </div>
    );
  };
  
  export default ExCalendar;
  